"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const ContactBook = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 17,
  height: 18,
  viewBox: "0 0 17 18",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M11.5 7.75a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0zm5-5.625v13.75a1.25 1.25 0 01-1.25 1.25H4a1.25 1.25 0 01-1.25-1.25V14H1.5a.625.625 0 110-1.25h1.25V9.625H1.5a.625.625 0 010-1.25h1.25V5.25H1.5A.625.625 0 011.5 4h1.25V2.125A1.25 1.25 0 014 .875h11.25a1.25 1.25 0 011.25 1.25zm-2.625 9.625a5.302 5.302 0 00-2.14-1.694 3.125 3.125 0 10-4.215 0c-.85.367-1.59.951-2.145 1.694a.625.625 0 001 .75 4.062 4.062 0 016.5 0 .625.625 0 101-.75z",
  className: "fill"
}));
var _default = exports.default = ContactBook;